import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import { Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { failedMessage } from "utils/httpClient";
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import Templateview from "pages/templateview";
import moment from "moment";
import InvoiceComponent from "./invoicereceipt";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
import { isEmpty } from "utils/utils";
// import * as pdfjsLib from 'pdfjs-dist';
// pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import workerUrl from 'pdfjs-dist/build/pdf.worker.min.js?url';
function MyOrders() {
  const [orderList, setOrderList] = useState([]);
  const [siteUrl, setSiteUrl] = useState('');
  const [base_url, setbaseurl] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [selectPage, setSelectPage] = useState("");
  const [templateViewPage, setTemplateViewPage] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [languageData, setLanguageData] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  const authData = loadFromLocalStorage("AUTH_DATA");
  const [reciptLink, setReciptLink] = useState("");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  useEffect(() => {
    getOrderList();
  }, [currentPage]);

  const getOrderList = async () => {
    let params = { limit: 6, offset: currentPage === 0 ? 0 : currentPage - 1 }
    let header = { token: authData?.token }
    const { data } = await apiCall("post", apiEndPoint.GETORDERSUBSCRIPTION, params, header);
    if (data.status === 200) {
      setbaseurl(data?.baseUrl)
      setOrderList(data.data);
      setTotalPages(Math.ceil(data?.total_data / 6));
    } else {
      setOrderList([]);
      failedMessage(data.message);
    }
    setLoading(false)
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleViewClick = (item) => {

    let valueData = item
    const aa = [valueData?.billing_details]
    let basic_plan_amount = 10 * 365;

    valueData['invoice_no'] = valueData?.order_id.slice(-3);
    valueData['order_date'] = moment(valueData?.createdDate).format('DD/MM/YYYY');
    valueData['user_detail'] = JSON.parse(aa);
    valueData['basic_plan_amount'] = basic_plan_amount;


    setOrderDetail(item);

    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDownloadPdf = async (recipt) => {
    if (!isEmpty(recipt)) {
      const response = await fetch(recipt);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'output.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  // const canvasRef = useRef(null);
  const loadPDF = async () => {
    //   const pdfUrl = "https://api.mydigitalindia.app:3000/generated_pdfs/output_1734591957860.pdf";
    //   const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
    //   const page = await pdf.getPage(1);
    //   const viewport = page.getViewport({ scale: 1.5 });
    //   const canvas = canvasRef.current;
    //   const context = canvas.getContext('2d');
    //   canvas.height = viewport.height;
    //   canvas.width = viewport.width;
    //   await page.render({ canvasContext: context, viewport }).promise;
  };

  return (
    <Fragment>
      <div>
        <div className="services-section mt-5">
          <div className="container text-center">
            <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
              {languageData?.myOrders}
            </h3>
            <br />
            <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
              {languageData?.hereYouCanManageAllYourOrders}
            </p>
          </div>
        </div>
        <Container className="" style={{ marginBottom: '1rem' }}>
          <div className="card mt-5">
            {orderList.length > 0 && orderList.map((item, i) => (
              <Card className="m-3" key={i}>
                <Row noGutters style={{ alignItems: 'center' }}>
                  <Col md={6}>
                    <div className="p-3">
                      <p className="mb-1"><strong>{languageData?.orderNo} : #{item?._id.slice(-4)} </strong></p>
                      {/* <p className="mb-1"><strong>Order name : {item?.path_name} </strong></p> */}
                      <p className="mb-1"><strong>{languageData?.dateOfPublish}</strong>: {moment.unix(item?.start_date).format('Do MMMM, YYYY')}</p>
                      <p className="mb-1"><strong>{languageData?.domainName}</strong>: {item?.domain}</p>
                      <p className="mb-1"><strong>{languageData?.dateOfRenewal}</strong>: {moment.unix(item?.end_date).format('Do MMMM, YYYY')}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="text-end p-3">
                      <Button
                        style={{ borderRadius: 15, width: 150, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                        size='md'
                        onClick={() => { setReciptLink(base_url + item?.invoice_link); handleViewClick(item); loadPDF(); }}
                      >
                        {languageData?.view}
                      </Button>  <br />
                      <Button className="mt-3"
                        // onClick={handleShow}
                        onClick={() => handleDownloadPdf(base_url + item?.invoice_link)}
                        style={{ borderRadius: 15, width: 150, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                        size='md'>
                        {languageData?.printReceipt}
                      </Button>


                      <Modal show={show} onHide={handleClose} backdrop="static" size="xl" style={{ background: 'white' }}
                        keyboard={false}>
                        {/* <Modal.Header closeButton>
                          </Modal.Header> */}
                        <Modal.Body>
                          <InvoiceComponent />
                        </Modal.Body>
                        <Modal.Footer>
                          <Button className="m-auto my-1" onClick={handleClose}
                            style={{ borderRadius: 15, width: 150, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                            size='md'>
                            {languageData?.downloadReceipt}
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))}
          </div>

          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
            size={"xl"} // Set modal size based on active tab
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h6>{''}</h6>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ height: '750px', border: '1px solid #ccc' }}>

                <div
                  style={{
                    padding: '20px',
                    maxWidth: '1000px',
                    margin: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <img src="assets/images/logodigitall.png" alt="logo" style={{ width: '200px' }} />
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <h4 style={{ fontWeight: 700, margin: 0 }}>Invoice no.: INV-{orderDetail?.invoice_no}</h4>
                    </div>
                  </div>

                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <h5 style={{ margin: 0 }}>TAX INVOICE</h5>
                  </div>

                  <div
                    style={{
                      marginBottom: '15px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ fontSize: '14px' }}>
                      <p style={{ margin: 0 }}>
                        <strong>Order no #{orderDetail?.invoice_no}</strong>
                      </p>
                      <p style={{ margin: 0 }}>
                        <strong>Bill To:</strong>
                      </p>
                      <p style={{ margin: 0 }}>{orderDetail?.user_detail?.name}</p>
                      <p style={{ margin: 0 }}>{orderDetail?.user_detail?.mobile}</p>
                      <p style={{ margin: 0 }}>{orderDetail?.user_detail?.email}</p>
                    </div>
                    <div style={{ textAlign: 'right', fontSize: '14px' }}>
                      <p style={{ marginBottom: 0 }}>
                        <strong>Date:</strong> {orderDetail?.order_date}
                      </p>
                    </div>
                  </div>

                  <table
                    style={{
                      width: '100%',
                      borderRadius: '10px',
                      overflow: 'hidden',
                      border: '2px solid #444',
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            backgroundColor: '#f0f0f0',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Description
                        </th>
                        <th
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            backgroundColor: '#f0f0f0',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          1 Year Basic Plan
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px', borderBottom: '1px solid #ccc' }}>
                          Rs {orderDetail?.basic_plan_amount}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Premium Domain
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px', borderBottom: '1px solid #ccc' }}>
                          Rs {orderDetail?.domain_price}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          AI Marketing
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px', borderBottom: '1px solid #ccc' }}>
                          Rs {orderDetail?.aimarketing_status ? orderDetail?.aimarketing_price : 0}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Sub Total
                        </td>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Rs {orderDetail?.total_amount}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            textAlign: 'right',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Taxable Amount
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px', borderBottom: '1px solid #ccc' }}>Rs 0</td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            textAlign: 'right',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          GST
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px', borderBottom: '1px solid #ccc' }}>Rs 0</td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            borderRight: '1px solid #ccc',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Total Amount
                        </td>
                        <td
                          style={{
                            padding: '10px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Rs {orderDetail?.total_amount}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div style={{ marginTop: '20px' }}>
                    <p style={{ fontSize: '14px' }}>
                      <strong>Plan Validity:</strong> 1 year from the date of Publish
                    </p>
                  </div>
                </div>



                {/* <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                  <Viewer fileUrl={reciptLink} />
                </Worker> */}

                {/* <Worker workerUrl={workerUrl}>
                  <Viewer fileUrl={'https://api.mydigitalindia.app:3000/generated_pdfs/output_1745843263169.pdf'} />
                </Worker> */}
                {/* <iframe
                  src={'https://api.mydigitalindia.app:3000/generated_pdfs/output_1745843263169.pdf'}
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                  title="PDF Viewer"
                /> */}

                {/* <canvas ref={canvasRef}></canvas> */}

                {/* <iframe
                  src={"https://api.mydigitalindia.app:3000/generated_pdfs/output_1735550954602.pdf"}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                /> */}
                {/* <iframe
                  src={reciptLink}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                /> */}
              </div>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </Fragment>
  );
}

export default MyOrders;